export const getCurrencySymbol = (currency) => {
  return currency === "USD" ? "$" : "₦" ;
};
